import ImageOne from '../images/ImageOne.jpg';
import ImageTwo from '../images/ImageTwo.jpg';
import ImageThree from '../images/ImageThree.jpg';
import ImageFour from '../images/ImageFour.jpg';

export const SliderData = [
    {
        title:'Luxury Villa In Bali,Indonesia',
        prices:'$4,400,000',
        path:"/home",
        label:'View Home',
        image:ImageOne,
        alt:'House1'
    },
    {
        title:'House in Calabose,Califonia',
        prices:'$5,200,000',
        path:"/home",
        label:'View Home',
        image:ImageTwo,
        alt:'House2'
    },
    {
        title:'House in San Jose,Costa Rica',
        prices:'$3,700,000',
        path:"/home",
        label:'View Home',
        image:ImageThree,
        alt:'House3'
    },
    {
        title:'Ocean View House,Mauritus',
        prices:'$6,000,000',
        path:"/home",
        label:'View Home',
        image:ImageFour,
        alt:'House4'
    }
];